let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cix9p")).then(() => parcelRequire('1beT1'));